<template>
  <div>
    <top-header></top-header>
    <site-header></site-header>
    <inner-banner title="Frequently Asked Questions" current-page="FAQ"></inner-banner>

    <!-- faq section -->
    <section class="w3l-faq py-5">
      <div class="container py-md-5 py-4">
        <div class="title-heading-w3 text-center mx-auto mb-5 pb-sm-4">
          <h3 class="title-main">Common <span>Questions</span></h3>
        </div>
        <div class="row">
          <div class="col-lg-8 mx-auto">
            <div class="faq-section">
              <div class="faq-item" v-for="(item, index) in faqItems" :key="index">
                <input type="checkbox" :id="'q' + (index + 1)">
                <label :for="'q' + (index + 1)">{{ item.question }}</label>
                <p>{{ item.answer }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- //faq section -->

    <footer-component></footer-component>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import FooterComponent from '@/components/Footer.vue'
import InnerBanner from '@/components/InnerBanner.vue'

export default {
  name: 'FaqPage',
  components: {
    TopHeader,
    SiteHeader,
    FooterComponent,
    InnerBanner
  },
  data() {
    return {
      faqItems: [
        {
          question: 'I am a beginner/no experience in speaking Chinese, what course should I take?',
          answer: 'Our comprehensive course is suitable for you. This course aims to help learners acquire basic communication skills. The topics cover most daily situations, like shopping, ordering food and workplace conversation for example. If you want to know more, check the link below.'
        },
        {
          question: 'What\'s the class schedule?',
          answer: 'The schedule depends on your availability, the students and the teacher. Our working hours are from 9:00 am-9:00 pm, Mon-Sun, Beijing time.'
        },
        {
          question: 'How many people are in a class?',
          answer: 'If it\'s a 1-1 class, then just the student and teacher. If it\'s a group there will be at least 2-6 people in a class.'
        },
        {
          question: 'Do you record your classes?',
          answer: 'We now only provide live stream classes for online. Zoom would be the platform for people from the different countries. Tencent Meeting is an option for those in China. In person sessions are available in Chengdu, China.'
        },
        {
          question: 'How is the course structured?',
          answer: 'Our courses are all based on textbooks and learning materials. Online courses have digital versions provided. Materials can be provided before class. After which you will have notes, homework and materials to aid you with revision.'
        },
        {
          question: 'How long do I need to finish a course?',
          answer: 'This depends on the course. Variables like the speed of learning and the size of class. Average hours for a course is 50 hours.'
        }
      ]
    }
  }
}
</script>

<style scoped>


.w3l-faq {
  background: var(--bg-color);
}

.title-heading-w3 {
  max-width: 800px;
}

.title-main {
  font-size: 2.5em;
  font-weight: 700;
  color: var(--heading-color);
  margin-bottom: 1rem;
}

.title-main span {
  color: var(--primary-color);
}

.faq-section {
  margin: 40px 0;
  position: relative;
}

.faq-item {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px var(--shadow-color);
  transition: all 0.3s ease;
}

.faq-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px var(--shadow-color);
}

.faq-item input {
  position: absolute;
  opacity: 0;
  z-index: -1;
}

.faq-item label {
  position: relative;
  display: block;
  padding: 20px 25px;
  font-size: 1.1em;
  font-weight: 600;
  background: var(--bg-color);
  color: var(--text-color);
  border-left: 4px solid var(--primary-color);
  cursor: pointer;
  transition: all 0.3s ease;
}

.faq-item label:hover {
  background: var(--hover-color);
}

.faq-item p {
  display: none;
  padding: 25px;
  margin: 0;
  background: var(--bg-color);
  color: var(--text-secondary);
  line-height: 1.6;
  border-top: 1px solid var(--border-color);
}

.faq-item input:checked ~ label {
  background: var(--primary-color);
  color: #fff;
}

.faq-item input:checked ~ p {
  display: block;
}

.faq-item label::after {
  content: '+';
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.5em;
  font-weight: 400;
  transition: all 0.3s ease;
}

.faq-item input:checked ~ label::after {
  content: '-';
  transform: translateY(-50%) rotate(180deg);
}

@media (max-width: 768px) {
  .title-main {
    font-size: 2em;
  }
  
  .faq-item label {
    font-size: 1em;
    padding: 15px 20px;
  }
  
  .faq-item p {
    padding: 20px;
  }
  
  .faq-item label::after {
    right: 20px;
  }
}
</style> 